<template>
  <div>
    <register-banner></register-banner>
    <register-feature-list></register-feature-list>
    <register-feature-description></register-feature-description>
    <Testimonials></Testimonials>
    <call-to-action></call-to-action>
  </div>
</template>

<script>
import RegisterBanner from "../components/Register/RegisterBanner.vue";
import RegisterFeatureList from "../components/Register/RegisterFeatureList.vue";
import RegisterFeatureDescription from "../components/Register/RegisterFeatureDescription.vue";
import CallToAction from "../components/CallToAction/CallToAction.vue";
import Testimonials from "../components/Testimonials/Testimonials.vue";
export default {
  name: "register",
  components: {
    RegisterBanner,
    RegisterFeatureList,
    RegisterFeatureDescription,
    CallToAction,
    Testimonials
  },
  data() {
    return {};
  },
  methods: {
    onSubmit() {},
    onReset() {}
  }
};
</script>

<style></style>
